import { Injectable } from '@angular/core';
import { VehicleType } from '@services/cleanfill-api/cleanfill-api.generated';

@Injectable({
  providedIn: 'root'
})
export class HaulerMapperService {
  constructor() {}
  vehicleTypeEnumtoArray() {
    return Object.keys(VehicleType)
      .filter(key => isNaN(Number(key)))
      .map(key => VehicleType[key]);
  }

  getLabel(type: VehicleType): string {
    switch (type) {
      case VehicleType.Triaxle:
        return 'Triaxle';
      case VehicleType.TriaxleAndPup:
        return 'Triaxle and pup';
      case VehicleType.Trailer:
        return 'Trailer';
      case VehicleType.TrailerLiveBottom:
        return 'Trailer live bottom';
    }
  }
}
